module.exports = __webpack_public_path__ + "img/distribute-spacing-horizontal.b5f7bbbd.svg";